import { Table } from 'antd';
import React from 'react';
import { useNavigate } from 'react-router-dom';

import { Error403Unauthorized } from '@app/components';
import {
  PREFIX,
  RIGHTS_IS_ON,
  RIGHTS_SENDOUTS,
  SENDOUT_RECEIVERS_TABLE_HEADER,
  U_KEY,
} from '@app/constants';
import { useAccessRights, useRightsToSendouts } from '@app/hooks';
import { usePagination } from '@app/pages/Sendouts/hooks/usePagination';
import { SendoutsFilterForm } from '@app/pages/Sendouts/SendoutReceivers/components/SendoutsReceiversFilterForm';
import { useSendoutReceiversEffects } from '@app/pages/Sendouts/SendoutReceivers/hooks/useSendoutReceiversEffects';
import { adaptDataToTable } from '@app/pages/Sendouts/SendoutReceivers/utils/adaptDataToTable';

export const SendoutReceivers: React.FC = () => {
  const navigate = useNavigate();

  const { hasUserRightForModuleView: hasUserSpecialRightToSendouts } =
    useAccessRights(RIGHTS_SENDOUTS, RIGHTS_IS_ON);
  const { hasOrganizationRightToModule } = useRightsToSendouts();

  const {
    pageNumber,
    rowsPerPage,
    totalRowsCount,
    setTotal,
    change,
    setPageNumber,
    setRowsPerPage,
  } = usePagination();

  const {
    sendoutClients,
    isGetSendoutClientsLoading,
    setGetSendoutClientsParams,
    refetchSendoutClients,
  } = useSendoutReceiversEffects(pageNumber, rowsPerPage, setTotal);

  const areRightsToPage =
    hasOrganizationRightToModule && hasUserSpecialRightToSendouts;

  if (!areRightsToPage) {
    return <Error403Unauthorized />;
  }

  return (
    <div className={`${PREFIX}sendout-receivers`}>
      <SendoutsFilterForm
        setGetSendoutClientsParams={setGetSendoutClientsParams}
        setPageNumber={setPageNumber}
        setRowsPerPage={setRowsPerPage}
        refetchSendoutClients={refetchSendoutClients}
      />
      <Table
        className="sendout-receivers-table"
        rowClassName="client-item"
        loading={isGetSendoutClientsLoading}
        rowKey={(record) => String(record[U_KEY])}
        columns={SENDOUT_RECEIVERS_TABLE_HEADER}
        dataSource={adaptDataToTable(
          sendoutClients?.Data?.length ? sendoutClients.Data : [],
          navigate
        )}
        pagination={{
          size: 'default',
          showSizeChanger: true,
          total: totalRowsCount,
          pageSize: rowsPerPage,
          position: ['bottomLeft'],
          current: pageNumber,
          onChange: change,
          showTotal: (total, range) =>
            `Показаны ${range[0]}-${range[1]} из ${total}`,
        }}
      />
    </div>
  );
};
